var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assets-by-class-table" }, [
    _c(
      "table",
      { staticClass: "assets-by-class-table__table" },
      [
        _c("AssetsByGroupTableHeader", {
          attrs: {
            "allowed-actions": _vm.allowedActions,
            "columns-config": _vm.columnsConfig,
            readonly: _vm.readonly,
            "is-all-selected": _vm.isAllSelected,
            "is-some-selected": _vm.isSomeSelected,
            "show-rentability": _vm.shouldShowRentability,
            "loading-rent-asset": _vm.loadingRentAsset,
            "recomendacao-tooltip": _vm.recomendacaoTooltip,
            "comentario-tooltip": _vm.comentarioTooltip,
            "visible-columns": _vm.visibleColumns
          },
          on: { "select-all": _vm.selecionarAtivosCarteira },
          scopedSlots: _vm._u(
            [
              _vm.$scopedSlots["actions-header"]
                ? {
                    key: "actions-header",
                    fn: function() {
                      return [_vm._t("actions-header")]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        }),
        _vm.groups.length === 0
          ? _c("tbody", [
              _c("tr", { staticClass: "assets-by-class-table__no-results" }, [
                _c(
                  "td",
                  {
                    staticClass: "assets-by-class-table__no-results-column",
                    attrs: { colspan: _vm.totalVisibleColumns }
                  },
                  [_vm._v(" Nenhum ativo encontrado para a sua pesquisa. ")]
                )
              ])
            ])
          : _vm._l(_vm.groups, function(g) {
              return _c(
                "tbody",
                { key: g.name },
                [
                  _c("AssetsByGroupTableGroupRow", {
                    attrs: {
                      "allowed-actions": _vm.allowedActions,
                      "columns-config": _vm.columnsConfig,
                      group: g,
                      "estatisticas-classe": _vm.estatisticasClasse,
                      "show-rentability": _vm.shouldShowRentability,
                      readonly: _vm.readonly,
                      "map-class-rent": _vm.mapClassRent,
                      "benchmarks-by-class": _vm.benchmarksByClass,
                      "class-vol-fmt-by-name": _vm.classVolFmtByName,
                      "class-inicio-fmt-by-name": _vm.classInicioFmtByName,
                      "class-rend-text": _vm.classRendTextByName[g.name] || "",
                      "visible-columns": _vm.visibleColumns
                    },
                    on: {
                      "select-classe": _vm.selecionarAtivosClasse,
                      "open-save-benchmark": _vm.openSaveBenchmark
                    }
                  }),
                  _vm._l(g.assets, function(ativo) {
                    return _c("AssetsByGroupTableRow", {
                      key: g.name + "-" + ativo.id,
                      attrs: {
                        "allowed-actions": _vm.allowedActions,
                        "columns-config": _vm.columnsConfig,
                        asset: ativo,
                        "asset-aplicacao-text":
                          _vm.assetAplicacaoFmtById[ativo.id],
                        "asset-negative": !!_vm.assetNegativeById[ativo.id],
                        "asset-pct-text": _vm.assetPctById[ativo.id] || "0,00%",
                        "asset-rend-text":
                          _vm.assetRendTextById[ativo.id] || "",
                        "asset-stats": _vm.statisticsAssets[ativo.id],
                        "asset-stats-fmt":
                          _vm.assetStatsFmtById[ativo.id] || {},
                        "asset-view": _vm.assetViewById[ativo.id] || {},
                        "composicao-fundos": _vm.composicaoFundos,
                        "selected-assets": _vm.ativosSelecionadosInside,
                        "show-rentability": _vm.shouldShowRentability,
                        readonly: _vm.readonly,
                        "visible-columns": _vm.visibleColumns,
                        suitability: _vm.suitabilityByAssetId[ativo.id] || null,
                        "sugestoes-pendentes":
                          _vm.sugestoesPendentesById[ativo.id],
                        "ativos-do-cliente": _vm.ativosDoCliente,
                        "movimentacoes-das-sugestoes":
                          _vm.movimentacoesDasSugestoes
                      },
                      on: {
                        "aporte-resgate": _vm.handleRowAporteResgate,
                        "change-name": _vm.changeName,
                        "open-delete": _vm.handleRowOpenDelete,
                        "open-detalhes": _vm.handleRowOpenDetalhes,
                        "open-new-asset": _vm.handleRowOpenNewAsset,
                        "open-portability": _vm.handleRowOpenPortabilidade,
                        "open-vincular": _vm.handleRowOpenVincular,
                        "update-selected-assets": _vm.handleRowUpdateSelected
                      }
                    })
                  }),
                  g.controls.showControls
                    ? _c(
                        "tr",
                        {
                          key: g.name + "-pager",
                          staticClass: "assets-by-class-table__group-pager"
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass:
                                "assets-by-class-table__group-pager-column",
                              attrs: { colspan: _vm.totalVisibleColumns }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "assets-by-class-table__group-pager-content"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "assets-by-class-table__group-pager-rpp"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Linhas por página:")
                                      ]),
                                      _c("v-select", {
                                        staticClass:
                                          "assets-by-class-table__group-pager-rpp-select",
                                        attrs: {
                                          value: g.controls.rpp,
                                          items: _vm.pageSizeOptions,
                                          "menu-props": { offsetY: true },
                                          dense: "",
                                          "hide-details": ""
                                        },
                                        on: {
                                          change: function(val) {
                                            return _vm.onChangeGroupPageSize({
                                              name: g.name,
                                              val: val
                                            })
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "assets-by-class-table__group-pager-text"
                                    },
                                    [_vm._v(" " + _vm._s(g.pager.label) + " ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "assets-by-class-table__group-pager-actions"
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled: !g.pager.canPrev
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.prevGroupPage(g.classe)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-left")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled: !g.pager.canNext
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.nextGroupPage(g.classe)
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-right")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            }),
        _c("tbody", [
          _c("tr", { staticClass: "assets-by-class-table__table-total" }, [
            _c(
              "td",
              {
                staticClass:
                  "assets-by-class-table__table-total-column assets-by-class-table__table-total-column--ativo",
                attrs: { colspan: _vm.totalRowLeadingColspan }
              },
              [_vm._v(" PL Total ")]
            ),
            _c(
              "td",
              {
                staticClass: "assets-by-class-table__table-total-column",
                class: _vm.plTotalClass
              },
              [_vm._v(" " + _vm._s(_vm.plTotalText) + " ")]
            ),
            _vm.totalRowTrailingColspan > 0
              ? _c("td", {
                  staticClass: "assets-by-class-table__table-total-column",
                  attrs: { colspan: _vm.totalRowTrailingColspan }
                })
              : _vm._e()
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }